import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { IconAccess, IconAlarm, IconWarn, IconZoom } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo4.mp4';
import subVideo5 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo5.mp4';

export default {
  type: '건설 솔루션',
  banner: {
    title: '건설 자재의 위치와 이동을 실시간으로 파악하고 자산 관리를 자동화하세요.',
    desc: '건설 현장 내 자재와 장비의 위치를 추적하고, 반출입 내역과 이동 경로를 자동으로 기록해 분실을 방지하고 관리 업무를 간소화합니다.',
  },

  video: {
    title: '건설 자산의 흐름을 실시간으로 통제하고, 반입·반출 이력을 자동으로 저장하세요',
    desc: '위치추적 태그를 통해 자재와 장비의 현재 위치 및 이동 이력을 자동 수집하고, 관리자에게 시각화된 데이터를 제공하여 자산의 분실 위험을 줄이고 운영 효율성을 높입니다.',
    play: video,
  },

  func: [
    {
      theme: '자산 위치 실시간 확인과 반입·반출 자동기록',
      title: '실시간 자산 위치 추적',
      desc: '위치 태그를 부착한 자산은 현장 내 위치를 ±1~2m 정확도로 실시간 확인할 수 있으며, 자재 분실·방치 등을 사전에 예방할 수 있도록 관리자 화면에 지도 기반으로 표시됩니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      video: subVideo1,
    },
    {
      title: '자동 반출입 인식 및 기록',
      desc: '게이트웨이 기반 인프라를 활용해 자재가 특정 구역을 벗어날 경우 자동으로 반출 이벤트가 기록되며, 다시 들어올 경우 반입으로 저장되어 수기로 작성하던 자산 로그를 대체합니다.',
      sub1: '빠른 데이터 연동',
      icon1: IconTvocGray,
      sub2: '실시간 위치 추적',
      icon2: IconBinocularsGray,
      video: subVideo2,
    },
    {
      title: '위치 기반 이상 상황 탐지',
      desc: '장비나 자산이 비인가 구역에 장시간 머무르거나 반입 없이 반출될 경우 자동 경고가 발생하며, 이를 통해 보안 수준을 강화하고 이상 징후에 대한 실시간 대응이 가능합니다.',
      sub1: '근접 기준 거리 설정',
      icon1: IconRulerGray,
      sub2: '대응 방식 설정',
      icon2: IconBellGray,
      video: subVideo3,
    },
    {
      title: '고정 자산 및 이동 장비 통합 관리',
      desc: '고정형 설비부터 이동형 자재까지 동일한 시스템에서 위치 추적과 출입 기록을 통합 관리할 수 있어, 자산 유형별 운영 관리 체계를 단일 플랫폼으로 일원화할 수 있습니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '실시간 위치 추적',
      icon2: IconBinocularsGray,
      video: subVideo4,
    },
    {
      theme: '자산 관리 자동화 및 리포트 시스템',
      title: '이동 경로 기반 작업 이력 생성',
      desc: '장비의 이동 경로와 체류 장소를 자동 기록하여, 누가 어떤 자산을 언제 어디서 사용했는지 추적 가능한 자산 사용 로그를 확보할 수 있습니다.',
      sub1: '대응 방식 설정',
      icon1: IconBellGray,
      sub2: '외부 시스템 연동',
      icon2: IconChainLinkGray,
      video: subVideo1,
    },
    {
      title: '자산 사용 시간 및 가동률 분석',
      desc: '장비의 실사용 시간과 위치 데이터를 분석하여 자산의 활용도와 비효율성을 파악하고, 미사용 자산의 재배치를 통해 운영 효율을 높일 수 있습니다.',
      sub1: '대응 방식 설정',
      icon1: IconBellGray,
      sub2: '외부 시스템 연동',
      icon2: IconChainLinkGray,
      video: subVideo2,
    },
    {
      title: '자산 반입·반출 이력 리포트화',
      desc: '날짜별, 구역별 자산 반출입 내역을 자동 집계하여 일·주·월 단위로 보고서를 생성하고, 투입 대비 회수 비율 등 주요 지표도 시각적으로 제공합니다.',
      sub1: '대응 방식 설정',
      icon1: IconBellGray,
      sub2: '외부 시스템 연동',
      icon2: IconChainLinkGray,
      video: subVideo3,
    },
    {
      title: '안전 및 품질 관리 연계 활용',
      desc: '자산이 지정된 보관 장소를 벗어나거나 사용 전 점검 기록이 없는 경우 경고 알림을 제공해, 장비 오용과 품질 관리 누락을 방지하는 관리체계를 강화할 수 있습니다.',
      sub1: '대응 방식 설정',
      icon1: IconBellGray,
      sub2: '외부 시스템 연동',
      icon2: IconChainLinkGray,
      video: subVideo4,
    },
  ],
  subfunc: {
    title: '주요기능 요약',
    desc: '현장에서 미숙한 자재관리는 생산성에 직접적인 영향을 끼칩니다. 최적화된 프로세스를 통해서 효율성을 높이고 낭비되는 인적 자원을 비롯한 리소스들을 제거할 수 있습니다. 이를 위해 오브로는 최적화된 다양한 기능들을 제공합니다.',

    data: [
      {
        icon: IconChartRadius,
        title: '리포트 및 분석',
        desc: '현장 데이터를 기반으로 보고서 및 분석 자료를 생성할 수 있습니다.',
      },
      {
        icon: IconBell,
        title: '실시간 알람 기능',
        desc: '자재에 이상 상황이 발생하는 경우 알람을 보내 즉각적으로 대처할 수 있습니다.',
      },
      {
        icon: IconRoute,
        title: '동선 이력 조회',
        desc: '자재가 현장에서 움직였던 동선을 조회하여 데이터화 할 수 있습니다.',
      },
      {
        icon: IconDashboard,
        title: '현황 파악',
        desc: '현재 얼마나 많은 자재가 어디로 이동하고 있는지 파악합니다.',
      },
      {
        icon: IconWarning,
        title: '이탈 감지',
        desc: '자재가 현장에서 이탈하거나 잘못된 곳으로 이동하는 것을 감지합니다.',
      },
      {
        icon: IconSearch,
        title: '동선 패턴 분석',
        desc: '자재가 현장에서 얼마만큼 사용되고 언제 쓰였는지 분석할 수 있습니다.',
      },
      {
        icon: IconChainLink,
        title: '데이터 연동',
        desc: 'RFID, IOT, 보안, 영상 등의 시스템과 연결하여 효율적으로 활용할 수 있습니다.',
      },
      {
        icon: IconSecurity,
        title: '데이터 보안',
        desc: '높은 데이터 보안 수준을 유지하여 신뢰성이 높은 솔루션을 제공합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'constructionEquipment',
    },
    {
      data: 'constructionSafety',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
